import { TenantApi } from 'src/app/hickory-api';

export class MockTenantApi extends TenantApi { }
